'use strict';

module Patersons {
    export interface UserCompany {
        companyName: string;
        companyImage: string;
        companyPdfImage: string;
        contactEmail: string;
        contactPhone: string;
        disclaimerEmail?: string;
        disclaimerWeb?: string;
        footerEmail?: string;
        footerWeb?: string;
        footerPDF?: string;
        faviconImage?: string;
        enableFeature?:boolean;
        enableWholesaleClientsResearch: boolean;

        colorPrimary?: string;
        colorPrimaryDarker?: string;
        colorSecondary?: string;
        colorTertiary?: string;
        colorLink?: string;
    }
    export class UserCompanyService extends BaseService {
        userCompany: UserCompany = null;
        isGettingData: boolean;
        isFaviconSet: boolean;
        isThemeSet: boolean;

        private waitForGettingData(): ng.IPromise<boolean> {
            var deferred = this.q.defer<boolean>();

            var check = () => {
                setTimeout(() => {
                    if(!this.isGettingData){
                        deferred.resolve(true);
                    }else{
                        check();
                    }
                }, 300)
            } 

            check()

            return deferred.promise;
        }

        setFavicon() {
            if(this.userCompany && this.userCompany.faviconImage && !this.isFaviconSet){
              $("#favicon").attr("href",this.userCompany.faviconImage);
              $("#favicon-shortcut").attr("href",this.userCompany.faviconImage);
              this.isFaviconSet = true;
            }
        }

        setTheme(){
            if(this.userCompany.colorPrimary && this.userCompany.colorPrimaryDarker && this.userCompany.colorTertiary && this.userCompany.colorSecondary && !this.isThemeSet){
                    document.documentElement.style.setProperty('--color-primary', this.userCompany.colorPrimary );
                    document.documentElement.style.setProperty('--color-primary-darker', this.userCompany.colorPrimaryDarker);
                    document.documentElement.style.setProperty('--color-tertiary', this.userCompany.colorTertiary);
                    document.documentElement.style.setProperty('--color-secondary', this.userCompany.colorSecondary);
                    cssVars({
                        variables: {
                            '--color-primary': this.userCompany.colorPrimary,
                            '--color-primary-darker': this.userCompany.colorPrimaryDarker,
                            '--color-tertiary': this.userCompany.colorTertiary,
                            '--color-secondary': this.userCompany.colorSecondary,
                          }
                    });
                    this.isThemeSet = true;

            }    
        }

        getUserCompany(): ng.IPromise<UserCompany> {
            //provide a fallback company so that the portal does not fail if the API is down
            var fallbackCompany: UserCompany = {
                companyName: "Canaccord Genuity",
                companyPdfImage: "/assets/content/CG WM Digital Black-01.svg",
                companyPdfImage: "/assets/content/CG WM Digital Black-01.svg",
                contactEmail: "CGAU-CGA@cgf.com",
                contactPhone: "1300 582 256",
                enableWholesaleClientsResearch: false,
            }
            var deferred = this.q.defer<UserCompany>(); // Type the deferred to get better 'intellisense' support
            if(this.isGettingData){
                this.waitForGettingData().then(() => {
                    deferred.resolve(this.userCompany);
                })
            }else{
                if(this.userCompany === null){
       
                    this.isGettingData = true
                    var promise = this.get("/dataService/api/userCompany")
                    promise.then((data) => {
                        this.userCompany = data;
                        this.isGettingData = false
                        this.setFavicon()
                        this.setTheme()
                        deferred.resolve(this.userCompany);
                    }, (err) => {
                        this.isGettingData = false
                        this.setFavicon()
                        this.setTheme()
                        deferred.resolve(fallbackCompany);
                    });
                }else{
                    this.isGettingData = false
                    this.setFavicon()
                    deferred.resolve(this.userCompany);
                }
            }
            return deferred.promise;
        };
    }
}